module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "copyright-page"
    }
  }, [_c('p', {
    staticClass: "copyt",
    attrs: {
      "id": "copyright"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_ii"
    }
  }), _vm._v("H"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("OW TO")]), _vm._v(" S"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("PEAK")]), _vm._v(" S"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("CIENCE")]), _vm._v(": "), _c('em', [_vm._v("Gravity, Relativity, and Other Ideas That Were Crazy Until Proven Brilliant")]), _c('br'), _vm._v("Copyright © 2016 by Hachette Livre (Marabout)"), _c('br'), _vm._v("Translation copyright © 2018 by The Experiment, LLC")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Originally published in France as "), _c('em', [_vm._v("Prenez le temps d’e-penser")]), _vm._v(" by Hachette Livre in 2016.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("First published in North America by The Experiment, LLC in 2018.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("All rights reserved. Except for brief passages quoted in newspaper, magazine, radio, television, or online reviews, no portion of this book may be reproduced, distributed, or transmitted in any form or by any means, electronic or mechanical, including photocopying, recording, or information storage or retrieval system, without the prior written permission of the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("The Experiment, LLC | 220 East 23rd Street, Suite 600 | New York, NY 10010-4658"), _c('br'), _c('a', {
    attrs: {
      "href": "http://theexperimentpublishing.com",
      "target": "_blank"
    }
  }, [_vm._v("theexperimentpublishing.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Many of the designations used by manufacturers and sellers to distinguish their products are claimed as trademarks. Where those designations appear in this book and The Experiment was aware of a trademark claim, the designations have been capitalized.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("The Experiment’s books are available at special discounts when purchased in bulk for premiums and sales promotions as well as for fund-raising or educational use. For details, contact us at "), _c('a', {
    attrs: {
      "href": "mailto:info@theexperimentpublishing.com"
    }
  }, [_vm._v("info@theexperimentpublishing.com")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Names: Benamran, Bruce, 1977-")]), _vm._v(" "), _c('p', {
    staticClass: "copyi"
  }, [_vm._v("Title: How to speak science : gravity, relativity, and other ideas that were crazy until proven brilliant / Bruce Benamran ; translated by Stephanie Delozier Strobel.")]), _vm._v(" "), _c('p', {
    staticClass: "copyi"
  }, [_vm._v("Other titles: Prenez le temps d’e-penser. English")]), _vm._v(" "), _c('p', {
    staticClass: "copyi"
  }, [_vm._v("Description: New York : The Experiment, 2018. | Originally published in France: Prenez le temps d’e-penser (Paris : Editions Marabout, 2015). | Identifiers: LCCN 2018018275 (print) | LCCN 2018018872 (ebook) | ISBN 9781615194209 (ebook)")]), _vm._v(" "), _c('p', {
    staticClass: "copyi"
  }, [_vm._v("Subjects: LCSH: Science—Popular works.")]), _vm._v(" "), _c('p', {
    staticClass: "copyi"
  }, [_vm._v("Classification: LCC Q162 (ebook) | LCC Q162 .B4613 (print) | DDC 500—dc23 LC record available at "), _c('a', {
    attrs: {
      "href": "https://lccn.loc.gov/2018018275",
      "target": "_blank"
    }
  }, [_vm._v("https://lccn.loc.gov/2018018275")])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Ebook ISBN 978-1-61519-420-9")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Cover design by Sarah Smith"), _c('br'), _vm._v("Text design by Sophie Appel"), _c('br'), _vm._v("Translated by Stephanie Delozier Strobel")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55681477","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/copyright.vue
// module id = 63
// module chunks = 0